module.exports = __webpack_public_path__ + "public/images/slider/speaker-1-circle.a8ea5bf9ad180e9b737d0ecff715225a.png";